import React from 'react';
import { cn } from '../../lib/utils';
import LoadingSpinner from './LoadingSpinner';

interface LoadingButtonProps {
  loading: boolean;
  loadingText: string;
  disabled?: boolean;
  children: React.ReactNode;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  onClick?: () => void;
}

const LoadingButton: React.FC<LoadingButtonProps> = ({
  loading,
  loadingText,
  disabled = false,
  children,
  className,
  type = 'submit',
  onClick,
}) => (
  <button
    type={type}
    disabled={loading || disabled}
    onClick={onClick}
    className={cn(
      'btn-primary w-full',
      (loading || disabled) && 'opacity-50 cursor-not-allowed',
      className
    )}
  >
    {loading ? (
      <span className="flex items-center justify-center gap-2">
        <LoadingSpinner />
        {loadingText}
      </span>
    ) : (
      children
    )}
  </button>
);

export default LoadingButton;
